var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.forms
      ? _c("div", { staticClass: "tls-popup--body-slot tls-selection-new" }, [
          _c("div", { staticClass: "tls-popup-line" }),
          _vm._v(" "),
          _c("div", { staticClass: "tls-field" }, [
            _c(
              "div",
              _vm._l(_vm.forms, function(form) {
                return _c("div", { staticClass: "tls-popup-view-form" }, [
                  _c("p", { staticClass: "tls-input-check--label" }, [
                    _vm._v("Reference: " + _vm._s(form.f_cai || form.f_id))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "tls-input-check--label" }, [
                    _vm._v(
                      "Surnames: " +
                        _vm._s(
                          form.f_pers_surnames + " " + form.f_pers_givennames
                        )
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "tls-input-check--label" }, [
                    _vm._v("Passport Number: " + _vm._s(form.f_pass_num))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "tls-input-check--label" }, [
                    _vm._v("Trav Purpose: " + _vm._s(form.f_trav_purpose))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "tls-input-check--label" }, [
                    _vm._v("phone: " + _vm._s(form.f_pers_mobile_phone))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tls-popup-line" })
                ])
              }),
              0
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }